import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { AboutChefRainey } from "@/components/AboutChefRainey";
import { Footer } from "@/components/Footer";

export const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App bg-cream min-h-screen antialiased">
      <Navbar forceSolid />
      <main>
        <AboutChefRainey />
      </main>
      <Footer />
    </div>
  );
};
